import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { AddExceptionDialogData } from './add-exception-dialog.data';

@Component({
    selector : 'add-exception-dialog',
    template: require('./add-exception-dialog.component.html'),
    styles: [require('./add-exception-dialog.component.scss')]
})
export class AddExceptionDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: AddExceptionDialogData) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-exception-dialog/add-exception-dialog.component.ts